import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import {APP_NAMES} from '../../constants';
import {useMapContext} from '../../context/MapContext';
const BedroomsElement = ({bedrooms, propertyType}) => {
    const mapContext = useMapContext();

    switch (mapContext.appName) {
        case APP_NAMES.TRIPBOARDS:
            return (
                <Fragment>
                    <div
                        className="MapHit__bedrooms MapHit__label"
                        aria-hidden="true"
                    >
                        {bedrooms}
                    </div>
                </Fragment>
            );
        default:
            if (bedrooms > 0) {
                return (
                    <Fragment>
                        <div
                            className="MapHit__propertyType MapHit__label"
                            aria-hidden="true"
                        >
                            {propertyType}
                        </div>
                        <div
                            className="MapHit__bedrooms MapHit__label"
                            aria-hidden="true"
                        >
                            <FormattedMessage
                                id="bedroomsAbbreviationParam"
                                description="bedrooms abbreviation label"
                                defaultMessage="{bedrooms} BR"
                                values={{
                                    bedrooms,
                                }}
                            />
                        </div>
                    </Fragment>
                );
            }
            return (
                <Fragment>
                    <div
                        className="MapHit__propertyType MapHit__label"
                        aria-hidden="true"
                    >
                        {propertyType}
                    </div>
                </Fragment>
            );
    }
};

export default BedroomsElement;
